function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h80v80H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.646 43.57c5.6.007 4.74.003 6.272.027 1.532.023 2.4-.617 2.603-1.834l-.022-5.498c-.004-1.028.072-2.059-.47-3.007-1.152-2.014-3.689-2.713-5.665-1.561-1.977 1.152-2.645 3.718-1.493 5.732a4.178 4.178 0 003.06 2.078c2.968.019 5.195.028 6.684.027 1.612 0 1.752-1.327 1.801-2.493.033-.777-.063-4.295-.027-6.792",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.697 31.348c-.27-1.102-.845-2.048-1.66-2.702.375.041.781.087 1.224.138 9.418 1.084 16.89 6.508 17.695 16.877-.109 7.167-1.678 13.213-11.618 17.178-.036-.066.017.454 0 4.689-.011 2.685-8.825 2.685-8.832 0v-4.69h-8.667l.039 4.69c-.138 2.682-8.949 2.689-8.92 0v-4.69c-7.524-.579-12.122-2.97-14.519-8.982-.14.013-1.642.01-4.708 0-2.514.325-3.793-1.579-3.834-5.71-.042-4.131.97-6.407 3.038-6.828h4.138c2.097-6.561 5.265-10.665 12.514-12.534.022-1.5-.033-6.832 0-7.627 5.886-.14 8.164 2.84 8.164 7.627 4.556.008 6.673-.121 7.9-.248a5.134 5.134 0 00-2.067 2.812H34.01c-.898 0-1.626.728-1.626 1.626v.043c0 .898.728 1.626 1.626 1.626h14.889c.898 0 1.626-.728 1.626-1.626v-.043c0-.898-.728-1.626-1.626-1.626h-2.2z",
  stroke: "#371447",
  fill: "#C0D0D8"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  cx: 17.871,
  cy: 40.502,
  rx: 1.814,
  ry: 1.831
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.366 15.133c.283-.64.441-1.348.441-2.094 0-2.831-2.274-5.127-5.08-5.127-2.804 0-5.078 2.296-5.078 5.127 0 2.652 1.995 4.834 4.553 5.1",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  cx: 44.719,
  cy: 20.362,
  rx: 5.079,
  ry: 5.126
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.243 34.484l.129-.385a5.18 5.18 0 00.16-1.287c0-2.83-2.273-5.126-5.078-5.126-2.806 0-5.08 2.295-5.08 5.126 0 .405.047.798.134 1.175l.135.551",
  stroke: "#371447"
}));

function SvgCoreSavingsLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCoreSavingsLg;